import styled from 'styled-components';

export const YoutubeWrap = styled.div`
  position: absolute;
  width: 96.05%;
  height: 33.51%;
  top: 64.72%;
  left: 2.2%;

  > div {
    width: 100%;
    height: 100%;
  }

  iframe {
    width: 100%;
    height: 100%;
  }
`;

export const SubmitWrap = styled.div`
  background-color: #FCFCFC;
  padding: 32px 0;
`;

export const SubmitImg = styled.button`
  width: 83.09%;
  margin: 0 auto;
  display: flex;
  padding-top: 21.168%; 
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: contain; 
  border: none;
  outline: none;
`;

export const TipWrap = styled.div`
  background-color: #FCFCFC;
  padding-bottom: 40px;
`;

export const TipImg = styled.div`
  width: 67.18%; 
  margin: 0 auto; 
  padding-top: 11.61%; 
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover; 
`;
